import React, { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import axios from "axios"

function EvaluatedComponent({ data }) {
  const [customerName, setCustomerName] = useState("")
  const [title, setTitle] = useState("")
  const [responsibleAnalyst, setResponsibleAnalyst] = useState("")

  useEffect(() => {
    if (data) {
      console.log(data)
      setCustomerName(data.customerName || "")
      setTitle(data.title || "")
      setResponsibleAnalyst(data.responsibleAnalyst || "")
    }
  }, [data])

  return (
    <>
      <p>Prezado(a) {customerName}</p>

      <div className="msg-form">
        <p>
          Informamos que a pesquisa de satisfação referente à ocorrência abaixo
          já consta como respondida em nosso sistema.{" "}
        </p>
        <p>
          Agradecemos pela sua colaboração e, caso tenha alguma dúvida ou
          sugestão, entre em contato conosco pelo e-mail{" "}
          <a className="a-survey" href="mailto:gerenciaservicos@ngxit.com.br">
            gerenciaservicos@ngxit.com.br
          </a>
          .
        </p>
      </div>

      <div className="desc-wrapper">
        <div className="desc-wrapper-each">
          <p>Título da ocorrência:</p>
          <div>{title}</div>
        </div>
        <div className="desc-wrapper-each">
          <p>Analista responsável:</p>
          <div>{responsibleAnalyst}</div>
        </div>
      </div>
    </>
  )
}

export default EvaluatedComponent
